import styles from './HistoryView.module.scss';
import classNames from 'classnames';
import ManaString from '@/components/Spellify/ManaString/ManaString';
import { ScryfallCard } from '@scryfall/api-types';

type Props = {
  isViewingHistory: boolean;
  guesses: string[];
  card: ScryfallCard.Normal
  buttonState: {[index: string]: string},
}

const HistoryView: React.FC<Props> = ({isViewingHistory, guesses, card, buttonState}: Props) => {
  return (
    <div className={classNames(styles.overlay, !isViewingHistory && styles.noDisplay)}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Number</th>
            <th>Guess</th>
            <th>Result</th>
          </tr>
        </thead>
        <tbody>
          {guesses.map((guess, index) => {
            let guessString = guess
            const isCardGuess = guessString.length > 1 && guessString[0] !== '{'
            if (isCardGuess) {
              guessString = ''
              let guessIndex = 0
              card.name.split('').forEach((letter, index) => {
                if (letter.match(/[a-zA-Z0-9]/)) {
                  guessString += guess[guessIndex]
                  guessIndex++
                } else {
                  guessString += letter
                }
              })
            }
            return index % 2 === 1 ? null : (
            <tr key={index}>
              <td>{index / 2 + 1}</td>
              <td><ManaString pid="guess" className={styles.noMargin} line={guessString}/></td>
              <td>
                {isCardGuess && '❌'}
                {!isCardGuess && buttonState[guess] === 'green' && '✅'}
                {!isCardGuess && buttonState[guess] === 'red' && '❌'}
              </td>
            </tr>
          )})}
        </tbody>
      </table>
    </div>
  )
}

export default HistoryView;